import { Component, OnInit } from '@angular/core';
import { AppServiceManager } from "common/services/appServiceManager";
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from "primeng/api";
import globalVariable from "../../../globalVariable/globalVariable.json";
import { ICompany } from 'app/shared/Domains/company';
import { IUser } from 'app/shared/Domains/IUser';
import { Configuration } from "config/config";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { AppUtils } from 'common/services/app.util';


@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.css']
})
export class UserInformationComponent implements OnInit {
  errorExempleNumber: string;
  companyImage: ICompany
  fullName: any;
  gymName : any
  emailAdress: string;
  company: string;
  branch: string;
  address: any;
  selectedBranch: any;
  message: string;
  isSuccess: boolean;
  isError: boolean;
  branchName: string;
  username : string;
  loading: boolean;
  isMessage: boolean;
  isSubmitted: boolean;
  branchDetail: any;
  phoneNumber: string = '';
  isPhoneValid = false;
  EmailplaceholderText: string = 'Email (Optional)';
  isSessionExpired: boolean = false;
  private readonly demoEmail = 'admin@demogymf11.com';
  private readonly demoPassword = 'abcd@1234';

  constructor(
    private LanguageService: LanguageService,
    public config: Configuration,
    private MessageService: MessageService,
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
    private router: Router,
  ) { }
	setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("UserInformationComponent", label);
  }
  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe(params => {
        console.log('company:', params.get('company'));
        console.log('branch:', params.get('branch'));
        const token = localStorage.getItem("token");
        this.isSessionExpired = this.isTokenExpired(token);
        if (token && !this.isSessionExpired) {
            console.log("Token is valid, user is logged in.");
            this.router.navigateByUrl("members");
        } else {
            console.log("Token is invalid or expired, redirecting to login.");
            localStorage.removeItem("currentUser");
            localStorage.removeItem("currentRole");
            localStorage.removeItem("token");
            localStorage.removeItem("expiration");
            localStorage.removeItem("currentCompany");
        }
        this.company = params.get("company");
        this.branch = params.get('branch');
        // this.getBranchById();
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if(currentUser){
          this.username = currentUser.email;
        }
        // this.branches = this.branches.filter(branch => branch._id == this.branch);
        // if (this.branches.length > 0) {
        //   this.selectedBranch = this.branches[0];
        //   // console.log( this.selectedBranch);
        // }
        // else {
        //   console.log("Sorry, Please contact your administrator.");
        // }
      });


    this.errorExempleNumber = globalVariable.exampledata.pakNumber;

  }
  // getBranchById() {
  //   this.appServiceManager.get('branches/' + this.branch).subscribe(
  //     (res) => {
  //       if (res) {
  //         this.selectedBranch = res;
  //         this.branchDetail = res;
  //       } else {
  //         this.MessageService.clear();
  //         this.MessageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
  //       }
  //     },
  //     (error) => {
  //       this.MessageService.clear();
  //       this.MessageService.add({ severity: 'error', summary: 'Error Message', detail: error });
  //     }
  //   );
  // }

  setEmailPlaceholder(pattern: string) {
    this.EmailplaceholderText = pattern; // Change placeholder on focus
  }

  resetEmailPlaceholder() {
    this.EmailplaceholderText = 'Email (Optional)'; // Reset placeholder on blur
  }

  errorMsgClose() {
    this.isMessage = false;
    this.isError = false;
    this.isSuccess = false;
  }
  submit(form: any) {
    if (!this.isPhoneValid || !this.phoneNumber?.trim()) {
      this.isMessage = true;
      this.isError = true;
      this.isSuccess = false;
      this.message = `${this.setLabel("validMobileErrorLabel")} ${this.errorExempleNumber}`;
      Object.keys(form.controls).forEach(controlName => {
        form.controls[controlName].markAsTouched();
      });
      return;
    }

    if (form.valid) {

      let payload = form.value;
      payload['contact'] = this.phoneNumber;
      payload['branch'] = this.branch;
      payload['company'] = this.company;
      payload['username'] = this.username;
      if (this.isSessionExpired) {
        this.loading = true;
      }
      this.appServiceManager
        .post(`system/branches/${this.branch}/login-logs`, payload)
        .subscribe(
          (res: any) => {
            if (res.status === true) {
              if (this.isSessionExpired) {
                this.performDemoLogin();
                return;
              }
              form.reset();
              this.isSuccess = true;
              this.isError = false;
              this.isMessage = true;
            } else {
              this.loading = false;
              this.message = "Sorry, Something went wrong.";
              this.isMessage = true;
              this.isSuccess = false;
              this.isError = true;
            }
          },
          (error: any) => {
            this.isMessage = true;
            this.message = "Sorry, Something went wrong.";
            this.loading = false;
            this.isSuccess = false;
            this.isError = true;
            if (this.isSessionExpired) {
              this.performDemoLogin();
            }
          });
          
    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
    }
  }

  isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return !payload.exp || currentTime >= payload.exp;
  } catch (e) {
    return true; // if token invalid, treat as expired
  }
}

  private performDemoLogin(): void {
    const user = new IUser();
    user.email = this.demoEmail;
    user.password = this.demoPassword;

    this.appServiceManager.post('users/authenticate', user).subscribe(
      (res: any) => {
        if (res.error === null) {
          const loggedInUser = res.data.user;
          localStorage.setItem('currentUser', JSON.stringify(loggedInUser));
          localStorage.setItem('currentRole', JSON.stringify(res.data.role));
          localStorage.setItem('currentCompany', JSON.stringify(res.data.company[0]));
          localStorage.setItem('currentBranch', JSON.stringify(res.data.branch[0]));

          const appUtils = new AppUtils();
          appUtils.setImagesPath(loggedInUser.company, loggedInUser.branch);

          const expiresInDuration = res.data.expiresIn;
          const expirationDate = new Date(Date.now() + expiresInDuration * 1000);
          localStorage.setItem('token', JSON.stringify(res.data.token));
          localStorage.setItem('expiration', JSON.stringify(expirationDate.toISOString()));

          this.router.navigateByUrl('members');
          return;
        }

        this.loading = false;
        this.message = res.error || "Sorry, Something went wrong.";
        this.isMessage = true;
        this.isError = true;
        this.navigateToDemoLogin();
      },
      () => {
        this.loading = false;
        this.message = "Sorry, Something went wrong.";
        this.isMessage = true;
        this.isError = true;
        this.navigateToDemoLogin();
      }
    );
  }

  private navigateToDemoLogin(): void {
    this.router.navigate(['/login'], {
      queryParams: {
        email: this.demoEmail,
        password: this.demoPassword
      },
      queryParamsHandling: '',
      state: {
        email: this.demoEmail,
        password: this.demoPassword
      }
    });
  }



}